import {WidgetController} from './../widget';
import {banks, currencyAccounts} from '../../../services/arsweb/RoutingPaths';

import pieChartTemplate from './pieChartsWidget.html';
import { CONSOLIDATION_CURRENCY_PARAMS } from '../../../controller/CommonViewController';

/** @ngInject */
export function pieCharts() {
    return {
        restrict: 'E',
        scope: {
            controller: '='
        },
        transclude: 'true',
        templateUrl: pieChartTemplate,
        controller: PieChartsController,
        controllerAs: 'pieChartsController'
    };
}
export const TOP_NUMBER = 5;
export class PieChartsController extends WidgetController{
    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, 'WIDGET_PIE_CHARTS', 'mdi-action-visibility', 'pieChartsWgtKey');

        // Listen to consolidation currency selection change
        $scope.$on('consolidationCurrency.change', () => {
            if(this.$scope.controller) {
                this.accountService.service.config.params = {};
                this.loadWidgetContent();
            }
        });
    }

    loadChartsConfiguration() {
        const flotService = this.$scope.controller.flotService;

        this.pieOptionsCurr =  {
            series: {
                pie: {
                    show: true,
                    label: {
                        show: false
                    }
                }
            },
            grid: {
                hoverable: true,
                clickable: true
            },
            legend: {
                show: true,
                noColumns: 1,
                container:'#legendContainerCurr',
                labelFormatter: flotService.legendLabel
            }
        };

        this.pieOptionsBank = {
            series: {
                pie: {
                    show: true,
                    label: {
                        show: false
                    }
                }
            },
            grid: {
                hoverable: true,
                clickable: true
            },
            legend: {
                show: true,
                noColumns: 1,
                container: '#legendContainerBank',
                labelFormatter: flotService.legendLabel
            }
        };
    }

    loadWidgetContent() {
        const flotService = this.$scope.controller.flotService;
        this.loadChartsConfiguration();
        //rest call to populate the data SHOULD BE PASS AS PARAMETER
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$scope.controller.$scope.consolitationcurrency.code;

        this.accountService.getUserSummaryData(currencyAccounts).then((currencyData) => {
            this.pieDataset = currencyData.accountSummaries.slice(0, TOP_NUMBER);
            this.pieDataset = flotService.constructChart(currencyData.accountSummaries, this.pieDataset, this.userService);
          }).then(() => {
              this.accountService.getUserSummaryData(banks).then((bankData) => {
                this.pieBankDataset = bankData.accountSummaries.slice(0, TOP_NUMBER);
                this.pieBankDataset = flotService.constructChart( bankData.accountSummaries, this.pieBankDataset, this.userService);
            });
        });
    }
}
